module.exports = __webpack_public_path__ + "img/4.5b32a7b0.png";